export default "__VITE_ASSET__BY93KMOo__"